/*eslint-disable*/
import api from '../'

class AntonymsApi {
    // get: /antonyms
    static getAntonymsByParams (params) {
        return api.axios.get('/antonyms', { params })
            .then(response => response.data);
    }
}

export default AntonymsApi;
